<template>
  <section class="createNewLink">
    <div class="setNewLink">
      <!--loading img-->
      <div
        v-show="loading"
        class="mask"
      >
        <img
          src="~image/search-load.gif"
        >
      </div>
      <!--content top warn-->
      <div
        v-if="headerWarnVisible"
        class="link-warn"
      >
        <span
          style="position: relative;display: inline-block;"
        >
          {{ warningTip }}
        </span>
      </div>
      <!--content-->
      <div
        class="content-box"
      >
        <div class="dialog-content">
          <div class="link-row">
            <span class="approval-tip" />
            <span
              v-show="!linkShareFormData.URL_VALUE && linkStatus !== 'creating'"
              class="delivery-icon"
            >
              <svg class="icon icon-i-link">
                <use xlink:href="#link-share" />
              </svg>
            </span>
            <div
              v-show="linkStatus === 'create'"
              class="link-url-span"
              :class="{'no-link-border': !hasDelivery}"
            >
              <span class="no-link">{{ $t('还没有创建分享链接') }}</span>
            </div>

            <div
              v-show="linkShareFormData.URL_VALUE"
              class="link-url-span url-show"
              :class="{creating:linkStatus === 'creating'}"
            >
              <a
                class="has-link"
                target="_blank"
                :style="{width: add_link_pwd ? '197px' : '235px'}"
                @click="openClientWin(linkShareFormData.URL_VALUE)"
              >{{ linkShareFormData.URL_VALUE }}</a>
              <input
                ref="link_copy_box"
                v-model="linkUrlCopy"
                type="text"
                class="link_copy_box"
                :title="linkUrlCopy"
              >
              <span
                v-if="linkPassword.length > 0"
                class="link-txt-password"
              >({{ $t('提取码：') }}{{ linkPassword }})</span>
            </div>
            <div
              id="link-share-two-dimensional-code-icon"
              class="link-share-two-dimensional-code-icon"
              v-if="linkShareFormData.URL_VALUE"
              @click="qrcode_show = !qrcode_show"
            >
              <div
                v-show="qrcode_show"
                id="link-share-two-dimensional-code-box"
                class="link-share-two-dimensional-code-box"
                @click.stop
              >
                <div
                  id="link-share-two-dimensional-code-pic"
                  class="link-share-two-dimensional-code-pic"
                  @contextmenu.stop
                >
                  <img
                    class="delivery-qrcode"
                    :src="qr_code_url"
                    :alt="this.$t('二维码')"
                  >
                </div>
                <div
                  id="link-share-two-dimensional-code-state"
                  class="link-share-two-dimensional-code-state"
                >
                  {{ $t('手机扫描二维码查看链接') }}
                </div>
                <div style="margin-top: 14px;color: #637282;text-align: left;">
                  {{ $t('发邮件分享链接') }}:
                </div>
                <div
                  style="margin-top: 16px"
                  class="link-row add-email clearfix"
                >
                  <label class="label">{{ $t('邮箱:') }}</label>
                  <div id="add-email">
                    <searchMember
                      ref="member_list"
                      :single="single"
                      :type="searchMemberType"
                      :position="position"
                      :disable="linkShareFormData.MAX_EXPIRATION_VALUE_DISABLE ||
                        showInApprovalWarn"
                      :placeholder="$t(placeholder)"
                      @watchSelected="watchSelected"
                      @showTips="showTips"
                    />
                  </div>
                </div>
                <div class="link-instruction clearfix">
                  <label class="label link-instruction-label">{{ $t('说明:') }}</label>
                  <textarea
                    id="link_mail_instruction"
                    v-model="mail_description"
                    :style="{width: lang === 'en' ? '330px' : ''}"
                    class="link_mail_instruction"
                    :placeholder="$t('添加邮件说明')"
                    maxlength="80"
                  />
                </div>
                <div
                  class="s-btn sendLink"
                  @click="sendLink"
                >
                  {{ $t('发送') }}
                </div>
                <div
                  class="c-btn sendLink cancel"
                  @click="qrcode_show = !qrcode_show"
                >
                  {{ $t('取消') }}
                </div>
              </div>
            </div>
            <input
              v-show="linkStatus === 'create'"
              id="link-create"
              type="button"
              :class="['lv-bn','lv-80', 's-btn','cp',pwVerified?'':'create-btn-disable']"
              name="create"
              :value="$t('新建链接')"
              :disabled="showInApprovalWarn || needAuth || !pwVerified"
              @click="createLink"
            >
            <input
              v-show="linkStatus === 'creating'"
              type="button"
              :class="['lv-bn','lv-80','s-btn','cp',pwVerified?'':'create-btn-disable']"
              name="create"
              :value="$t('新建中...')"
              :disabled="showInApprovalWarn || needAuth || !pwVerified"
            >
            <input
              v-show="linkStatus === 'copy'"
              id="link-copy"
              type="button"
              :class="['lv-bn','lv-80','s-btn','cp',pwVerified?'':'create-btn-disable']"
              name="copy"
              :value="$t('复制')"
              :disabled="linkShareFormData.MAX_EXPIRATION_VALUE_DISABLE ||
                showInApprovalWarn ||
                needAuth ||
                !pwVerified"
              @click="copylink"
            >
            <input
              v-show="linkStatus === 'save&copy'"
              id="link-copy-save"
              type="button"
              :class="['lv-bn','lv-80','s-btn','cp',pwVerified?'':'create-btn-disable']"
              name="update"
              :value="$t('保存并复制')"
              :disabled="showInApprovalWarn || needAuth || !pwVerified"
              @click="createLink"
            >
          </div>
          <div class="link-option">
            <div
              class="remark-row"
              :style="{zIndex: showInApprovalWarn ? -1 : 0}"
            >
              <span class="label">{{ $t('备注名：') }}</span>
              <div
                v-show="!remarkshow"
                class="remark"
                @click="remarkshow=true"
              >
                {{ linkShareFormData.CREATOR_REMARK_VALUE }}<span class="icon-remark" />
              </div>
              <input
                v-show="remarkshow"
                ref="remark"
                v-model="linkShareFormData.CREATOR_REMARK_VALUE"
                type="text"
                :style="{width: lang === 'en' ? '320px' : ''}"
                class="remark-name"
                maxlength="32"
                :disabled="showInApprovalWarn"
                @blur="remarkshow=false"
              >
              <span
                v-show="maxlenWarn"
                class="maxlength-warn-txt"
              >{{ $t('最多可输入32个字符') }}</span>
            </div>
            <div style="margin-top: 11px;color: #929CA9;font-size: 14px;">
              {{ $t('设置增强链接安全性') }}:
            </div>
            <div class="check-auth controlled-item clearfix">
              <!--<span class="label">{{$t('权限：')}}</span>-->
              <span
                v-show="linkShareFormData.UPLOAD_SHOW"
                class="item-wrapper auth-row upload"
                :class="{'disabled': linkShareFormData.UPLOAD_DISABLE || showInApprovalWarn}"
              >
                <input
                  id="common-delivery-upload"
                  v-model="linkShareFormData.UPLOAD"
                  type="checkbox"
                  name="common-delivery-upload"
                  :disabled="showInApprovalWarn"
                >
                <span
                  class="box-checkbox-inner"
                  :class="(
                    (linkShareFormData.UPLOAD && !linkShareFormData.IS_SNAPSHOT)?
                      (linkShareFormData.UPLOAD_DISABLE || showInApprovalWarn)?
                        'checkbox-disabled':'checkbox-checked': ''
                  )"
                  @click="checkOrNot('UPLOAD',linkShareFormData.UPLOAD_DISABLE)"
                />
                <label for="common-delivery-upload">{{ $t('允许上传') }}</label>
              </span>
              <span
                class="item-wrapper"
                :class="{'disabled': linkShareFormData.DOWNLOAD_DISABLE || showInApprovalWarn}"
              >
                <input
                  id="common-delivery-download"
                  v-model="linkShareFormData.DOWNLOAD"
                  type="checkbox"
                  name="common-delivery-download"
                  :disabled="showInApprovalWarn"
                >
                <span
                  class="box-checkbox-inner"
                  :class="(
                    linkShareFormData.DOWNLOAD?
                      (linkShareFormData.DOWNLOAD_DISABLE || showInApprovalWarn) ?
                        'checkbox-disabled':'checkbox-checked': ''
                  )"
                  @click="checkOrNot('DOWNLOAD',linkShareFormData.DOWNLOAD_DISABLE)"
                />
                <label for="common-delivery-download">{{ $t('允许下载') }}</label>
              </span>
              <span
                class="item-wrapper"
                :class="{'disabled': linkShareFormData.PREVIEW_DISABLE || showInApprovalWarn}"
              >
                <input
                  id="common-delivery-preview"
                  v-model="linkShareFormData.PREVIEW"
                  type="checkbox"
                  name="common-delivery-preview"
                  :disabled="linkShareFormData.PREVIEW_DISABLE ||showInApprovalWarn"
                >
                <span
                  class="box-checkbox-inner"
                  :class="(
                    linkShareFormData.PREVIEW?
                      (linkShareFormData.PREVIEW_DISABLE || showInApprovalWarn)?
                        'checkbox-disabled':'checkbox-checked': ''
                  )"
                  @click="checkOrNot('PREVIEW',linkShareFormData.PREVIEW_DISABLE)"
                />
                <label for="common-delivery-preview">{{ $t('允许预览文件') }}</label>
              </span>
              <span
                class="item-wrapper"
                :class="{'disabled': linkShareFormData.IS_SNAPSHOT_DISABLE || showInApprovalWarn}"
              >
                <input
                  v-model="linkShareFormData.IS_SNAPSHOT"
                  type="checkbox"
                  name="link_out"
                  :disabled="showInApprovalWarn || showAuthWarn"
                >
                <span
                  class="box-checkbox-inner"
                  :class="{'checkbox-checked':linkShareFormData.IS_SNAPSHOT}"
                  @click="checkOrNot('IS_SNAPSHOT',linkShareFormData.IS_SNAPSHOT_DISABLE)"
                />
                <label
                  :class="{'disable-check':linkShareFormData.IS_SNAPSHOT_DISABLE}"
                  style="margin-right: 2px"
                >{{ $t('文件快照') }}</label>
                <i class="snapshot ico-i-tip">
                  <div class="tip-show">
                    {{ $t('新建链接时勾选此项后不可取消。链接路径下所有文件以副本形式存在，不受源文件内容的增删和更新影响。') }}
                  </div>
                </i>
              </span>
              <span
                class="item-wrapper"
                :class="{'disabled': linkShareFormData.IS_LOGIN_VERIFY_DISABLE ||
                  showInApprovalWarn}"
              >
                <input
                  v-model="linkShareFormData.IS_LOGIN_VERIFY"
                  type="checkbox"
                  name="link_out"
                  :disabled="showInApprovalWarn || showAuthWarn"
                >
                <span
                  class="box-checkbox-inner"
                  :class="{'checkbox-checked':linkShareFormData.IS_LOGIN_VERIFY}"
                  @click="checkOrNot('IS_LOGIN_VERIFY',linkShareFormData.IS_LOGIN_VERIFY_DISABLE)"
                />
                <label
                  :class="{'disable-check':linkShareFormData.IS_LOGIN_VERIFY_DISABLE}"
                  style="margin-right: 2px"
                >{{ $t('登录认证') }}</label>
                <i class="loginverify ico-i-tip">
                  <div class="tip-show">{{ $t('开启登录认证后此链接需要登录网盘账户才可访问') }}</div>
                </i>
              </span>
            </div>
            <div class="secure-config">
              <div class="secure-content">
                <div
                  v-show="add_link_pwd"
                  class="config-row secure-row"
                  style="margin-top: 0;"
                >
                  <span
                    class="item-wrapper secure-wrapper disabled"
                  >
                    <input
                      v-model="linkShareFormData.IS_PROTECTED"
                      type="checkbox"
                      name="link_out"
                      :disabled="linkShareFormData.IS_PROTECTED_DISABLE || showAuthWarn"
                    >
                    <span
                      :class="{'checkbox-checked':linkShareFormData.IS_PROTECTED}"
                      class="box-checkbox-inner"
                      @click="checkOrNot('IS_PROTECTED',linkShareFormData.IS_PROTECTED_DISABLE)"
                    />
                    <label
                      class="secure-label"
                      :class="{'disable-check':showAuthWarn}"
                    >{{ $t('添加提取码') }}</label>
                  </span>
                  <input
                    v-show="linkShareFormData.IS_PROTECTED"
                    v-model="linkShareFormData.IS_PROTECTED_VALUE"
                    maxlength="6"
                    type="text"
                    :class="{
                      'input-invalidate':
                        !/^[A-Za-z0-9]+$/.test(linkShareFormData.IS_PROTECTED_VALUE)
                    }"
                    :disabled="showInApprovalWarn"
                    :placeholder="$t('请输入提取码')"
                  >
                  <span
                    v-show="linkShareFormData.IS_PROTECTED &&
                      linkShareFormData.IS_PROTECTED_VALUE.length === 0"
                    :class="{ 'text-invalidate': !linkShareFormData.IS_PROTECTED_VALUE}"
                    class="link-em-days"
                  >{{ $t('密码不能为空') }}</span>
                  <span
                    v-show="linkShareFormData.IS_PROTECTED &&
                      linkShareFormData.IS_PROTECTED_VALUE.length > 0 &&
                      !/^[A-Za-z0-9]+$/.test(linkShareFormData.IS_PROTECTED_VALUE)"
                    :class="{
                      'text-invalidate': linkShareFormData.IS_PROTECTED_VALUE.length > 0 &&
                        !/^[A-Za-z0-9]+$/.test(linkShareFormData.IS_PROTECTED_VALUE)}"
                    class="link-em-days"
                  >{{ $t('密码只能包含字母或数字') }}</span>
                </div>
                <div class="config-row secure-row">
                  <span
                    class="item-wrapper secure-wrapper"
                    :class="{
                      'disabled': linkShareFormData.MAX_EXPIRATION_DISABLE ||
                        showInApprovalWarn ||
                        showAuthWarn}"
                  >
                    <input
                      v-model="linkShareFormData.MAX_EXPIRATION"
                      type="checkbox"
                      name="link_out"
                      :disabled="showInApprovalWarn || showAuthWarn"
                    >
                    <span
                      class="box-checkbox-inner"
                      :class="{'checkbox-checked':linkShareFormData.MAX_EXPIRATION}"
                      @click="checkOrNot('MAX_EXPIRATION',
                                         linkShareFormData.MAX_EXPIRATION_DISABLE)"
                    />
                    <label
                      class="secure-label"
                      :class="{'disable-check':showAuthWarn}"
                    >{{ $t('添加链接有效期') }}</label>
                  </span>
                  <div
                    v-show="linkShareFormData.MAX_EXPIRATION"
                    class="calendar-box"
                  >
                    <el-date-picker
                      v-model="linkShareFormData.MAX_EXPIRATION_VALUE"
                      :disabled="showInApprovalWarn"
                      :clearable="false"
                      :editable="false"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                      :picker-options="pickerOptions"
                      @change="datePicked"
                    />
                  </div>
                  <span
                    v-show="linkShareFormData.MAX_EXPIRATION && !isExpiration"
                    class="link-em-days"
                  >
                    {{ $t('距到期还有{d}天{h}时{m}分', {
                      'd':lastday.days,
                      'h':lastday.hours,
                      'm':lastday.minutes
                    }) }}
                  </span>
                  <span
                    v-show="linkShareFormData.MAX_EXPIRATION && isExpiration"
                    class="link_ex_msg"
                  >{{ $t('链接已过期') }}</span>
                </div>
                <div
                  v-show="linkShareFormData.MAX_DOWNLOAD_COUNT_SHOW"
                  class="config-row secure-row"
                >
                  <span
                    class="item-wrapper secure-wrapper"
                    :class="{
                      'disabled': MAX_DOWNLOAD_COUNT_CHECKBOX_DISABLE_STATUS ||
                        showInApprovalWarn ||
                        showAuthWarn}"
                  >
                    <input
                      :checked="linkShareFormData.MAX_DOWNLOAD_COUNT
                        && linkShareFormData.DOWNLOAD"
                      type="checkbox"
                      name="link_out"
                      :disabled="MAX_DOWNLOAD_COUNT_CHECKBOX_DISABLE_STATUS || showAuthWarn"
                    >
                    <span
                      class="box-checkbox-inner"
                      :class="{
                        'checkbox-checked':linkShareFormData.MAX_DOWNLOAD_COUNT &&
                          linkShareFormData.DOWNLOAD}"
                      @click="checkOrNot(
                        'MAX_DOWNLOAD_COUNT',MAX_DOWNLOAD_COUNT_CHECKBOX_DISABLE_STATUS
                      )"
                    />
                    <label
                      class="secure-label"
                      :class="{'disable-check':showAuthWarn}"
                    >{{ $t('限制下载次数') }}</label>
                  </span>
                  <input
                    v-show="linkShareFormData.MAX_DOWNLOAD_COUNT && linkShareFormData.DOWNLOAD"
                    v-model="linkShareFormData.MAX_DOWNLOAD_COUNT_VALUE"
                    type="text"
                    :disabled="showInApprovalWarn"
                    :class="{ 'input-invalidate':maxDownloadCount }"
                    maxlength="4"
                  >
                  <span
                    v-if="/^[1-9][0-9]{0,3}$/.test(linkShareFormData
                      .MAX_DOWNLOAD_COUNT_VALUE)"
                  >
                    <span
                      v-if="linkShareFormData.MAX_DOWNLOAD_COUNT &&
                        linkShareFormData.DOWNLOAD &&
                        !isNew &&
                        linkShareFormData.INFO_REMAIN_DOWNLOAD_VALUE > 0"
                      class="link-em-days"
                    > {{ $t('还可下载{t}次',{t:linkShareFormData.INFO_REMAIN_DOWNLOAD_VALUE}) }}</span>
                    <span
                      v-if="linkShareFormData.MAX_DOWNLOAD_COUNT &&
                        linkShareFormData.DOWNLOAD &&
                        !isNew &&
                        linkShareFormData.INFO_REMAIN_DOWNLOAD_VALUE === 0"
                      class="link_ex_msg"
                    >{{ $t('下载次数已用尽') }}</span>
                  </span>
                </div>
                <div class="secure-validate">
                  <span
                    v-show="maxDownloadCount"
                    class="text-invalidate"
                  >
                    {{ maxDownloadCount }}
                  </span>
                </div>
              </div>
            </div>
            <div
              v-show="EOD_Frame_LI_SHOW_STATUS"
              class="eod"
            >
              <span
                class="item-wrapper"
                :class="{'disabled': EOD_ID_CHECKBOX_DISABLE_STATUS ||
                  showInApprovalWarn ||
                  showAuthWarn}"
              >
                <input
                  v-model="linkShareFormData.EOD_ID"
                  type="checkbox"
                  name="link_out"
                  :disabled="EOD_ID_CHECKBOX_DISABLE_STATUS || showAuthWarn"
                >
                <span
                  class="box-checkbox-inner"
                  :class="{'checkbox-checked':linkShareFormData.EOD_ID}"
                  @click="checkOrNot('EOD_ID',EOD_ID_CHECKBOX_DISABLE_STATUS)"
                />
                <label
                  :class="{'disable-check':showAuthWarn}"
                  style="margin-right: 2px"
                >{{ $t('开启本地管控') }}</label>
                <i class="eod-tip ico-i-tip">
                  <div class="tip-show">{{ $t('可通过设置，限制该链接的文件下载到本地的操作，目前仅支持windows系统') }}</div>
                </i>
              </span>
              <span
                v-show="linkShareFormData.EOD_ID &&
                  !WATERMARK_CONTENT_CHECKBOX_STATUS &&
                  eodValidate"
                class="text-invalidate"
              >{{ $t('请配置本地管控规则') }}</span>
              <div
                v-show="EOD_ID_CHECKBOX_STATUS"
                class="eod-detail"
                style="margin-top: 12px;"
              >
                <div
                  v-show="add_link_pwd"
                  class="config-row eod-row"
                  style="margin-top: 0;"
                >
                  <span
                    class="item-wrapper"
                    :class="{'disabled': controlledRule.staffOnly ||
                      showInApprovalWarn || showAuthWarn ||
                      linkShareFormData.EOD_PASSWORD_DISABLE }"
                  >
                    <input
                      v-model="linkShareFormData.EOD_PASSWORD"
                      type="checkbox"
                      name="link_out"
                      :disabled="linkShareFormData.EOD_PASSWORD_DISABLE || showAuthWarn"
                    >
                    <span
                      class="box-checkbox-inner"
                      :class="{'checkbox-checked':linkShareFormData.EOD_PASSWORD}"
                      @click="checkOrNot('EOD_PASSWORD',linkShareFormData.EOD_PASSWORD_DISABLE)"
                    />
                    <label :class="{'disable-check':showAuthWarn}">{{ $t('添加本地密码') }}</label>
                  </span>
                  <input
                    v-show="linkShareFormData.EOD_PASSWORD"
                    v-model="linkShareFormData.EOD_PASSWORD_VALUE"
                    type="text"
                    maxlength="16"
                    :class="{ 'input-invalidate':
                      !/^[A-Za-z0-9]+$/.test(linkShareFormData.EOD_PASSWORD_VALUE)}"
                    :disabled="showInApprovalWarn"
                    :placeholder="$t('请添加本地密码')"
                  >
                </div>
                <div class="eod-validate">
                  <span
                    v-show="linkShareFormData.EOD_PASSWORD &&
                      linkShareFormData.EOD_PASSWORD_VALUE.length === 0"
                    :class="{ 'text-invalidate': !linkShareFormData.EOD_PASSWORD_VALUE}"
                  >{{ $t('密码不能为空') }}</span>
                  <span
                    v-show="linkShareFormData.EOD_PASSWORD &&
                      linkShareFormData.EOD_PASSWORD_VALUE.length > 0 &&
                      !/^[A-Za-z0-9]+$/.test(linkShareFormData.EOD_PASSWORD_VALUE)"
                    :class="{ 'text-invalidate':
                      linkShareFormData.EOD_PASSWORD_VALUE.length > 0 &&
                      !/^[A-Za-z0-9]+$/.test(linkShareFormData.EOD_PASSWORD_VALUE)}"
                  >{{ $t('密码只能包含字母或数字') }} </span>
                </div>
                <div
                  v-show="add_link_pwd"
                  class="config-row eod-row"
                >
                  <span
                    class="item-wrapper"
                    :class="{'disabled': linkShareFormData.EOD_MAX_EXPIRATION_DISABLE ||
                      showInApprovalWarn ||
                      showAuthWarn}"
                  >
                    <input
                      v-model="linkShareFormData.EOD_MAX_EXPIRATION"
                      type="checkbox"
                      name="link_out"
                      :disabled="linkShareFormData.EOD_MAX_EXPIRATION_DISABLE || showAuthWarn"
                    >
                    <span
                      class="box-checkbox-inner"
                      :class="{'checkbox-checked':linkShareFormData.EOD_MAX_EXPIRATION}"
                      @click="checkOrNot(
                        'EOD_MAX_EXPIRATION',linkShareFormData.EOD_MAX_EXPIRATION_DISABLE
                      )"
                    />
                    <label :class="{'disable-check':showAuthWarn}">{{ $t('添加阅读有效期') }}</label>
                  </span>
                  <div
                    v-show="linkShareFormData.EOD_MAX_EXPIRATION"
                    class="calendar-box"
                  >
                    <el-date-picker
                      v-model="linkShareFormData.EOD_READ_START_TIME"
                      :disabled="showInApprovalWarn"
                      :class="{ 'input-invalidate': maxExpiration }"
                      :clearable="false"
                      :editable="false"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                      :picker-options="startPickerOptions"
                    />
                  </div>
                  <div
                    v-show="linkShareFormData.EOD_MAX_EXPIRATION"
                    class="calendar-box"
                  >
                    <el-date-picker
                      v-model="linkShareFormData.EOD_READ_END_TIME"
                      :disabled="showInApprovalWarn"
                      :class="{ 'input-invalidate': maxExpiration }"
                      :clearable="false"
                      :editable="false"
                      type="date"
                      :picker-options="endPickerOptions"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                    />
                  </div>
                </div>
                <div class="eod-validate">
                  <span
                    v-show="maxExpiration"
                    class="text-invalidate"
                  >
                    {{ maxExpiration }}
                  </span>
                </div>
                <div class="config-row eod-row">
                  <span
                    class="item-wrapper"
                    :class="{ 'disabled': controlledRule.staffOnly ||
                      showInApprovalWarn ||
                      showAuthWarn ||
                      linkShareFormData.LIMIT_MAX_READ_TIMES_VALUE}"
                  >
                    <input
                      v-model="linkShareFormData.MAX_READ_TIMES"
                      type="checkbox"
                      name="link_out"
                      :disabled="showInApprovalWarn || showAuthWarn"
                    >
                    <span
                      class="box-checkbox-inner"
                      :class="{'checkbox-checked':linkShareFormData.MAX_READ_TIMES}"
                      @click="checkOrNot('MAX_READ_TIMES',false)"
                    />
                    <label :class="{'disable-check':showAuthWarn}">{{ $t('限制阅读次数') }}</label>
                  </span>
                  <input
                    v-show="linkShareFormData.MAX_READ_TIMES"
                    v-model="linkShareFormData.MAX_READ_TIMES_VALUE"
                    type="text"
                    maxlength="4"
                    :class="{ 'input-invalidate': maxReadTimes }"
                    :disabled="showInApprovalWarn"
                    :placeholder="$t('请输入正整数')"
                  >
                  <span
                    v-show="linkShareFormData.MAX_READ_TIMES"
                    :style="{display: 'inline-block', width: lang === 'en'? '42px': '30px'}"
                  >{{ $t('次') }}</span>
                </div>
                <div class="eod-validate">
                  <span
                    v-show="maxReadTimes"
                    class="text-invalidate"
                  >
                    {{ maxReadTimes }}
                  </span>
                </div>
                <div class="config-row eod-row">
                  <span
                    class="item-wrapper"
                    :class="{'disabled': linkShareFormData.MAX_READ_DURATION_DISABLE ||
                      showInApprovalWarn ||
                      showAuthWarn}"
                  >
                    <input
                      v-model="linkShareFormData.MAX_READ_DURATION"
                      type="checkbox"
                      name="link_out"
                      :disabled="linkShareFormData.MAX_READ_DURATION_DISABLE || showAuthWarn"
                    >
                    <span
                      class="box-checkbox-inner"
                      :class="{'checkbox-checked':linkShareFormData.MAX_READ_DURATION}"
                      @click="checkOrNot(
                        'MAX_READ_DURATION',linkShareFormData.MAX_READ_DURATION_DISABLE
                      )"
                    />
                    <label :class="{'disable-check':showAuthWarn}">{{ $t('限制阅读时长') }}</label>
                  </span>
                  <input
                    v-show="linkShareFormData.MAX_READ_DURATION"
                    v-model="linkShareFormData.MAX_READ_DURATION_VALUE"
                    type="text"
                    maxlength="4"
                    :class="{ 'input-invalidate':maxReadDuration}"
                    :disabled="showInApprovalWarn"
                    :placeholder="$t('请输入正整数')"
                  >
                  <span
                    v-show="linkShareFormData.MAX_READ_DURATION"
                    :style="{display: 'inline-block', width: lang === 'en'? '50px': '30px'}"
                  >{{ $t('小时') }}</span>
                </div>
                <div class="eod-validate">
                  <span
                    v-show="maxReadDuration"
                    class="text-invalidate"
                  >
                    {{ maxReadDuration }}
                  </span>
                </div>
                <div style="margin-top: 12px;">
                  <span
                    class="item-wrapper"
                    :class="{ 'disabled': linkShareFormData.IS_PRINT_DISABLE ||
                      showInApprovalWarn ||
                      showAuthWarn}"
                  >
                    <input
                      v-model="linkShareFormData.IS_PRINT"
                      type="checkbox"
                      name="link_out"
                      :disabled="linkShareFormData.IS_PRINT_DISABLE || showAuthWarn"
                    >
                    <span
                      class="box-checkbox-inner"
                      :class="{'checkbox-checked':linkShareFormData.IS_PRINT}"
                      @click="checkOrNot('IS_PRINT',linkShareFormData.IS_PRINT_DISABLE)"
                    />
                    <label :class="{'disable-check':showAuthWarn}">{{ $t('允许打印') }}</label>
                  </span>
                  <span
                    class="item-wrapper"
                    :class="{'disabled': linkShareFormData.IS_READ_ONLY_DISABLE ||
                      showInApprovalWarn ||
                      showAuthWarn}"
                  >
                    <input
                      v-model="linkShareFormData.IS_READ_ONLY"
                      type="checkbox"
                      name="link_out"
                      :disabled="linkShareFormData.IS_READ_ONLY_DISABLE || showAuthWarn"
                    >
                    <span
                      class="box-checkbox-inner"
                      :class="{'checkbox-checked':linkShareFormData.IS_READ_ONLY}"
                      @click="checkOrNot('IS_READ_ONLY',linkShareFormData.IS_READ_ONLY_DISABLE)"
                    />
                    <label :class="{'disable-check':showAuthWarn}">{{ $t('文档只读') }}</label>
                  </span>
                  <span
                    class="item-wrapper"
                    :class="{'disabled': linkShareFormData.IS_EXPIRED_DELETE_DISABLE ||
                      showInApprovalWarn ||
                      showAuthWarn}"
                  >
                    <input
                      v-model="linkShareFormData.IS_EXPIRED_DELETE"
                      type="checkbox"
                      name="link_out"
                      :disabled="linkShareFormData.IS_EXPIRED_DELETE_DISABLE || showAuthWarn"
                    >
                    <span
                      class="box-checkbox-inner"
                      :class="{'checkbox-checked':linkShareFormData.IS_EXPIRED_DELETE}"
                      @click="checkOrNot(
                        'IS_EXPIRED_DELETE',linkShareFormData.IS_EXPIRED_DELETE_DISABLE
                      )"
                    />
                    <label :class="{'disable-check':showAuthWarn}">{{ $t('失效后删除') }}</label>
                  </span>
                </div>
              </div>
            </div>
            <div class="config-row watermark">
              <span
                class="item-wrapper watermark-wrapper"
                :class="{'disabled': WATERMARK_CONTENT_CHECKBOX_DISABLE_STATUS ||
                  showInApprovalWarn ||
                  showAuthWarn}"
              >
                <input
                  v-model="WATERMARK_CONTENT_CHECKBOX_STATUS"
                  type="checkbox"
                  name="link_out"
                  :disabled="WATERMARK_CONTENT_CHECKBOX_DISABLE_STATUS || showAuthWarn"
                >
                <span
                  class="box-checkbox-inner"
                  :class="{'checkbox-checked':linkShareFormData.WATERMARK_CONTENT}"
                  @click="checkOrNot('WATERMARK_CONTENT',
                                     WATERMARK_CONTENT_CHECKBOX_DISABLE_STATUS)"
                />
                <label
                  class="watermark-label"
                  :class="{'disable-check':showAuthWarn}"
                >
                  {{ $t('添加水印') }}
                  <i
                    v-show="!WATERMARK_CONTENT_CHECKBOX_DISABLE_STATUS"
                    class="eod-tip ico-i-tip"
                    style="position: absolute"
                  >
                    <div class="tip-show">{{ $t('文件下载至本地查看会附带水印，但不可打包下载和下载文件夹。') }}</div>
                  </i>
                </label>
                <span
                  v-show="WATERMARK_CONTENT_CHECKBOX_DISABLE_STATUS"
                  class="watermark-tip"
                >{{ $t('该文件类型，需开启本地管控才可添加水印') }}</span>
              </span>
              <input
                v-show="WATERMARK_CONTENT_VALUE_SHOW_STATUS"
                v-model="linkShareFormData.WATERMARK_CONTENT_VALUE"
                type="text"
                :class="pwVerified?'':'pw-input-red'"
                :disabled="showInApprovalWarn"
                :placeholder="$t('请输入水印内容')"
              >
            </div>
          </div>
          <div class="link-intro clearfix">
            <label class="label">{{ $t('说明：') }}</label>
            <div :style="{width: lang === 'en' ? '370px' : '404px',float:'right'}">
              <textarea
                v-model="linkShareFormData.DESCRIPTION_VALUE"
                maxlength="100"
                :placeholder="this.$t('添加链接说明')"
                class="link-share-input"
                :disabled="showInApprovalWarn"
              />
              <span style="color: #FF1B43;float: right;">
                {{ linkShareFormData.DESCRIPTION_VALUE.length }}/100
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import * as Util from 'js/util/util'

import { RICH_TXT_COPY } from 'components/business/linkshare/components/rich-text-copy'
import EOD_VALIDATE from 'js/linkshare-service/eod-validate'
import { formatDate } from 'js/linkshare-service/link-share-util'
import searchMember from '../search-member.vue' // 邮箱查询组件
import { deliveryCreateMethods } from '../../../../../static/js/linkshare-service/service-delivery'
import { getAuthData, canPreview } from '../../../../../static/js/linkshare-service/service-auth'
import { openUrlOutside } from '@filez/js-2-native'

const { postData } = require('js/api/getdata').default

export default {
  name: 'CreateNewLink',
  components: {
    searchMember,
  },
  mixins: [RICH_TXT_COPY, EOD_VALIDATE],
  props: {
    otherData: Object,
  },
  data() {
    return {
      loading: false,
      isNew: true,
      linkPassword: '',
      linkStatus: 'create',
      remarkshow: false,
      mail_description: '',
      approveDesc: '',
      linkShareFormData: {},
      waterMarkIsOpen: false,
      approvalCode: 0,
      metaData: {},
      placeholder: '点击或输入邮箱地址，多个地址以逗号或分号分隔',
      showDLTimeLimit: false,
      dl_limit: [this.$t('无限制'), 1, 2, 3],
      single: false,
      searchMemberType: 'email',
      position: 'top',
      qrcode_show: false,
      linkUrlCopy: '',
      add_link_pwd: true,
      hasDelivery: false,
      linkUrl: '',
      deliveryCode: '',
      qr_code_url: '',
      isfolder: '',
      startPickerOptions: {
        disabledDate: (date) => {
          if (this.linkShareFormData.EOD_READ_END_TIME) {
            return date.getTime() > new Date(this.linkShareFormData.EOD_READ_END_TIME).getTime()
          }
          return false
        },
      },
      endPickerOptions: {
        disabledDate: (date) => {
          if (this.linkShareFormData.EOD_READ_START_TIME) {
            const oneday = 24 * 60 * 60 * 1000 - 1
            const startTime = new Date(this.linkShareFormData.EOD_READ_START_TIME)
            return date.getTime() + oneday < startTime.getTime()
          }
          return false
        },
      },
      opt: {
        upload: '',
        download: '',
        preview: '',
      },
      oldOpt: {
        upload: '',
        download: '',
        preview: '',
      },
      param: {
        neid: '',
        mode: '',
        password: '',
        expiration: '',
        delivery_expired: '', // 链接是否过期
        description: '',
        name: '',
        dl_limit: this.$t('无限制'), // 下载次数限制
        staff_only: 1, // 是否仅内部成员访问
      },
      oldParam: {
        neid: '',
        mode: '',
        password: '',
        expiration: '',
        delivery_expired: '', // 链接是否过期
        description: '',
        name: '',
        dl_limit: this.$t('无限制'), // 下载次数限制
        staff_only: 1, // 是否仅内部成员访问
      },
      lastday: {
        days: '',
        hours: '',
        minutes: '',
      },
      warningTip: this.$t('该链接需要审批后生效'), // 链接框里的提示语
      showAuthWarn: false, // 链接弹框里 显示需要实名认证提示
      showApprovalWarn: false, // 链接弹框里 显示需要审批提示
      showInApprovalWarn: false, // 链接弹框里 显示在审批中...提示
      showRefuseApproval: false, // 链接弹框里 显示在拒绝审批的提示
      visibility: 'visible', // 是否显示链接内容， 初始为隐藏
      lang: Util.getLanguage(), // 获取语言
      pickerOptions: {
        disabledDate: (time) => {
          if (this.linkShareFormData.LIMIT_MAX_EXPIRATION_VALUE) {
            const expiration = (this.linkShareFormData.LIMIT_MAX_EXPIRATION_VALUE - 1)
              * 60 * 60 * 24 * 1000
            return time.getTime() > Date.now() + expiration
          }
          return false
        },
      },
      sendMailbtn: false,
      needAuth: false,
      maxlenWarn: false,
      isShowNewLinkFromFoot: false,
      link: [
        {
          ref: 'commonLink',
          name: this.$t('普通链接'),
          operateType: 1,
          code: 1,
          vm: this,
          get show() {
            return true
          },
        },
        {
          ref: 'secureLink',
          name: this.$t('安全链接'),
          operateType: 1,
          code: 2,
          vm: this,
          get show() {
            const { vm } = this
            return vm.haveSecureDelivery
          },
        },
        {
          ref: 'smartShare',
          name: 'Smart Share',
          operateType: 1,
          code: 3,
          vm: this,
          get show() {
            const { vm } = this
            return vm.haveSmartshareDelivery
          },
        },
      ],
      controlledRule: {},
      dlWarnMsg: this.$t('下载次数已用尽'),
      showDlWarnMsg: false,
      pwVerified: true, // 提取码校验通过，默认true
    }
  },
  computed: {
    headerWarnVisible() {
      return this.showAuthWarn
        || this.linkShareFormData.IS_APPROVAL
        || this.showInApprovalWarn
        || this.showRefuseApproval
    },
    MAX_DOWNLOAD_COUNT_CHECKBOX_DISABLE_STATUS: {
      // 限制下载次数,checkbox,禁用,算法
      get() {
        return !this.DOWNLOAD_LINKAGE_STATUS || this.linkShareFormData.MAX_DOWNLOAD_COUNT_DISABLE
      },
      set(newStatus) {
        this.linkShareFormData.MAX_DOWNLOAD_COUNT_DISABLE = newStatus
      },
    },
    WATERMARK_CONTENT_CHECKBOX_STATUS: {
      // 添加水印,checkbox,打勾,算法
      get() {
        if (this.WATERMARK_TITLE_STATUS) {
          return false
        }
        return this.DOWNLOAD_LINKAGE_STATUS && this.linkShareFormData.WATERMARK_CONTENT
      },
      set(newStatus) {
        this.linkShareFormData.WATERMARK_CONTENT = newStatus
      },
    },
    WATERMARK_CONTENT_CHECKBOX_DISABLE_STATUS: {
      // 添加水印,checkbox,禁用,算法
      get() {
        if (this.WATERMARK_TITLE_STATUS) {
          return true
        }
        return !this.DOWNLOAD_LINKAGE_STATUS || this.linkShareFormData.WATERMARK_CONTENT_DISABLE
      },
      set(newStatus) {
        this.linkShareFormData.WATERMARK_CONTENT_DISABLE = newStatus
      },
    },
    WATERMARK_TITLE_STATUS() {
      // 计算本地管控水印提示是否显示
      let watermarkTitleStatus
      if ((this.canAddWaterMark === false && !this.EOD_ID_CHECKBOX_STATUS)
        || (this.waterMarkIsOpen === false && !this.EOD_ID_CHECKBOX_STATUS)) {
        watermarkTitleStatus = true
      } else {
        watermarkTitleStatus = false
      }
      return watermarkTitleStatus
    },
    WATERMARK_CONTENT_VALUE_SHOW_STATUS() {
      // 计算水印输入框体是否显示
      return this.WATERMARK_CONTENT_CHECKBOX_STATUS
        && this.linkShareFormData.WATERMARK_CONTENT_VALUE_SHOW
    },
    WATERMARK_FRAME_LI_SHOW_STATUS() {
      // 计算水印框体是否显示
      return this.lenovoData.accountinfo.delivery_safe_switch
        || this.waterMarkIsOpen
        || (this.lenovoData.accountinfo.delivery_safe_switch
          && !this.WATERMARK_TITLE_STATUS)
    },
    EOD_ID_CHECKBOX_STATUS: {
      // 开启本地管控,checkbox,打勾,算法
      get() {
        return this.DOWNLOAD_LINKAGE_STATUS && this.linkShareFormData.EOD_ID
      },
    },
    EOD_Frame_LI_SHOW_STATUS: {
      // 本地管控框体,显隐,算法
      get() {
        return this.lenovoData.accountinfo.delivery_safe_switch
      },
    },
    EOD_ID_CHECKBOX_DISABLE_STATUS: {
      // 开启本地管控,checkbox,禁用,算法
      get() {
        return !this.DOWNLOAD_LINKAGE_STATUS || this.linkShareFormData.EOD_ID_DISABLE
      },
      set(newStatus) {
        this.linkShareFormData.EOD_ID_DISABLE = newStatus
      },
    },
    DOWNLOAD_LINKAGE_STATUS() {
      // 下载联动算法
      return this.linkShareFormData.DOWNLOAD
    },
    MAX_DOWNLOAD_COUNT_CHECKBOX_STATUS: {
      // 限制下载次数,checkbox,打勾,算法
      get() {
        return this.DOWNLOAD_LINKAGE_STATUS && this.linkShareFormData.MAX_DOWNLOAD_COUNT
      },
    },
    isExpiration() {
      const today = Util.formatDate(new Date(), 'yyyy/MM/dd')
      return new Date(this.linkShareFormData.MAX_EXPIRATION_VALUE).getTime()
        < new Date(today).getTime()
    },
    eodValidate() {
      const eod = ['EOD_PASSWORD', 'EOD_MAX_EXPIRATION', 'MAX_READ_TIMES', 'MAX_READ_DURATION', 'IS_PRINT', 'IS_READ_ONLY', 'IS_EXPIRED_DELETE']
      return eod.every((val) => !this.linkShareFormData[val])
    },
    authData() {
      // 计算原子权限
      return getAuthData(this.metaData.access_mode)
    },
    canUpload() {
      // 计算当前文件类型能否上传
      return this.isfolder
    },
    canPreview() {
      // 计算当前文件类型能否预览
      // 当为软航服务器的时候，外链按钮是不应该禁用的，所以增加了状态来判断是否为外链组件调用的该方法
      const sysConfig = {}
      this.lenovoData.custominfo.forEach((val) => {
        sysConfig[val.name] = val.value
      })

      return canPreview(this.metaData.mime_type, sysConfig) || this.isfolder
    },
    canAddWaterMark() {
      // 计算当前文件类型能否添加水印服务
      return /\.doc|docx|exl|exls|ppt|pptx|xls|xlsx|wps|wpt|dps|dpt|et|eet|pdf|psd|jpg|tif|gif|jpeg|eps|ai|bmp|tiff|png/.test(this.metaData.mime_type) || this.isfolder
    },
    showUpdate() {
      // 判断老版本和新的
      const paramFlag = this.isObjectValueEqual(this.param, this.oldParam)
      const optFlag = this.isObjectValueEqual(this.opt, this.oldOpt)
      return !(paramFlag && optFlag)
    },
    showMutexTip() {
      const { canUpload: upload, canPreview: preview, canDownload: download } = this.metaData
      if ((this.approvalCode !== 0) && upload && (preview || download)) {
        return true
      }
      return false
    },
    curFileInfo() {
      return this.$store.state.curFileInfo
    },
    lenovoData() {
      return this.$store.state.lenovoData.LenovoData
    },
  },
  watch: {
    linkShareFormData: {
      handler(val, oldval) {
        console.log(val, oldval, this.isNew)
        if (oldval && !this.isNew) {
          this.linkStatus = 'save&copy'
        }
      },
      deep: true,
    },
    remarkshow(newStatus) {
      if (newStatus) {
        this.$nextTick(() => {
          this.$refs.remark.focus()
        })
      }
    },
    'linkShareFormData.UPLOAD': {
      handler(newStatus) {
        // 上传,checkbox,联动,算法
        if (newStatus) {
          if (this.linkShareFormData.IS_APPROVAL) {
            this.linkShareFormData.DOWNLOAD = false
            this.linkShareFormData.PREVIEW = false
            this.linkShareFormData.IS_SNAPSHOT_DISABLE = false
          }
          this.linkShareFormData.IS_SNAPSHOT = false
        }
      },
    },
    'linkShareFormData.DOWNLOAD': {
      handler(newStatus) {
        // 上传,checkbox,联动,算法
        if (!newStatus) {
          this.linkShareFormData.EOD_ID = false
          this.linkShareFormData.MAX_DOWNLOAD_COUNT = false
        } else {
          if (!this.metaData.is_dir) {
            this.linkShareFormData.MAX_DOWNLOAD_COUNT = true
          }
        }
        if (newStatus && this.linkShareFormData.EOD_CONTROL) {
          this.linkShareFormData.EOD_ID = true
        }
        if (newStatus && this.linkShareFormData.LIMIT_MAX_DOWNLOAD_COUNT_VALUE > 0) {
          this.linkShareFormData.MAX_DOWNLOAD_COUNT = true
        }
        if (this.linkShareFormData.IS_APPROVAL) {
          if (newStatus) {
            this.linkShareFormData.UPLOAD = false
            this.linkShareFormData.IS_SNAPSHOT = true
            this.linkShareFormData.IS_SNAPSHOT_DISABLE = true
          }
          if (!newStatus && !this.linkShareFormData.PREVIEW) {
            this.linkShareFormData.IS_SNAPSHOT_DISABLE = false
          }
        }
      },
    },
    'linkShareFormData.PREVIEW': {
      handler(newStatus) {
        // 上传,checkbox,联动,算法
        if (this.linkShareFormData.IS_APPROVAL) {
          if (newStatus) {
            this.linkShareFormData.UPLOAD = false
            this.linkShareFormData.IS_SNAPSHOT = true
            this.linkShareFormData.IS_SNAPSHOT_DISABLE = true
          }
          if (!newStatus && !this.linkShareFormData.DOWNLOAD) {
            this.linkShareFormData.IS_SNAPSHOT_DISABLE = false
          }
        }
      },
    },
    'linkShareFormData.IS_SNAPSHOT': {
      handler(newStatus) {
        // 文件快照,checkbox,联动,算法
        if (this.linkShareFormData.UPLOAD) {
          this.linkShareFormData.UPLOAD = !newStatus
        }
      },
    },
    'linkShareFormData.EOD_PASSWORD': {
      handler(newStatus) {
        if (newStatus && this.linkShareFormData.IS_PROTECTED) {
          // 添加本地密码,打勾的时候,如果提取码打勾,
          // 那么本地密码与提取码value保持一致
          this.linkShareFormData.EOD_PASSWORD_VALUE = this.linkShareFormData.IS_PROTECTED_VALUE
        }
      },
    },
    /* 结束 */
    'linkShareFormData.MAX_EXPIRATION_VALUE': {
      handler() {
        let expiration = this.linkShareFormData.MAX_EXPIRATION_VALUE
        if (new Date(expiration).toString() === 'Invalid Date') {
          expiration = expiration.substring(0, expiration.length - 5).replace(/-/g, '/').replace('T', ' ')
        }
        this.leftTimer(Util.formatDate(new Date(expiration), 'yyyy-MM-dd')) // 监听日期变化，计算距离结束时间
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    showTipsNoIcon(info, tipsType = 'warn') {
      window.$toast.originToast({
        toastInfo: { info, tipsType },
        value: true,
        show: true,
        isIcon: false,
      })
    },
    init() {
      // otherData是setCmd传过来的，注意区分meta\new\historyCode这三类
      this.metaData = (this.otherData && this.otherData.meta)
        || this.curFileInfo // 获取选中项的相关数据
      this.isfolder = this.metaData.isDir || this.metaData.is_dir
      this.deliveryCode = (this.otherData && this.otherData.historyCode)
        || this.metaData.delivery_code
      this.linkShareFormData = this.otherData.linkShareFormData
      this.waterMarkIsOpen = this.otherData.waterMarkIsOpen
      this.qr_code_url = ''
      this.linkStatus = 'create'
      this.linkShareFormData.CREATOR_REMARK_VALUE = Util.formatDate(new Date(), 'yyyy-MM-dd hh:mm') + this.$t('新建的安全链接')
      this.visibility = 'visible'
    },
    validate() {
      if (this.linkShareFormData.IS_PROTECTED && !/^[A-Za-z0-9]+$/.test(this.linkShareFormData.IS_PROTECTED_VALUE)) {
        return false
      }
      if (this.linkShareFormData.DOWNLOAD && this.linkShareFormData.EOD_PASSWORD && !/^[A-Za-z0-9]+$/.test(this.linkShareFormData.EOD_PASSWORD_VALUE)) {
        return false
      }
      if (this.linkShareFormData.DOWNLOAD && this.maxExpiration) {
        return false
      }
      if (this.linkShareFormData.DOWNLOAD && this.maxReadTimes) {
        return false
      }
      if (this.linkShareFormData.DOWNLOAD && this.maxReadDuration) {
        return false
      }
      if (this.linkShareFormData.DOWNLOAD && this.maxDownloadCount) {
        return false
      }
      if (this.linkShareFormData.MAX_EXPIRATION && this.isExpiration) {
        return false
      }
      if (this.linkShareFormData.EOD_ID && this.eodValidate) {
        return false
      }
      return true
    },
    createLink(cb) {
      if (!this.validate()) {
        return false
      }
      const { path, path_type: pathType, nsid } = this.curFileInfo
      const linkShareCreateNeedParams = {
        path,
        path_type: pathType,
        linkShareSubmitFormDataParams: this.submitFormDataIntegrate(),
      }
      if (this.linkShareFormData.IS_APPROVAL) {
        this.$emit('reqApproval', {
          nsid,
          path,
          linkshareparams: linkShareCreateNeedParams,
        })
        return false
      }
      if (this.isNew) {
        this.linkStatus = 'creating'
      }
      this.loading = true
      deliveryCreateMethods(linkShareCreateNeedParams).then((res) => {
        // 当参数从接口重新赋值时,避免监听事件改变保存按钮的状态
        // this._linkShareApiChangeParams(false)
        // this.linkShareCreated()
        this.loading = false
        this.linkShareFormData.URL_VALUE = res.URL_VALUE
        this.qr_code_url = `/v2/image/qrcode?t=${res.URL_VALUE}&d=142`
        this.linkShareFormData.EOD_ID_VALUE = res.EOD_ID_VALUE
        this.linkShareFormData.LINK_ID = res.LINK_ID
        this.linkShareFormData.LINK_ID_VALUE = res.LINK_ID_VALUE
        this.linkShareFormData.DELIVERY_ID = res.DELIVERY_ID
        this.linkShareFormData.DELIVERY_ID_VALUE = res.DELIVERY_ID_VALUE
        this.linkShareFormData.REMAIN_DOWNLOAD = res.REMAIN_DOWNLOAD
        this.linkShareFormData.INFO_REMAIN_DOWNLOAD_VALUE = res.INFO_REMAIN_DOWNLOAD_VALUE
        this.linkPassword = res.PASSWORD
        if (this.linkShareFormData.IS_SNAPSHOT) {
          this.linkShareFormData.IS_SNAPSHOT_DISABLE = true
          this.linkShareFormData.UPLOAD_DISABLE = true
        }
        if (this.linkStatus === 'save&copy') {
          this.setRichTpl(res)
        }
        // this._linkShareStatus()
        this.$nextTick(() => {
          this.isNew = false
          this.linkStatus = 'copy'
          if (typeof cb === 'function') {
            cb()
          }
        })
      }).catch((err) => {
        this.loading = false
        this.showTipsNoIcon(this.$t(err.response.data.message))
        if (this.linkStatus === 'creating') {
          this.linkStatus = 'create'
        }
      })
    },
    copylink() {
      let expiration
      if (this.linkShareFormData.MAX_EXPIRATION) {
        // 添加链接有效期
        expiration = formatDate(this.linkShareFormData.MAX_EXPIRATION_VALUE, 'yyyy-MM-dd')
      } else {
        expiration = ''
      }
      const item = {
        url: this.linkShareFormData.URL_VALUE,
        size: this.linkShareFormData.SIZE,
        expire: expiration,
        path: this.curFileInfo.path,
        PASSWORD: this.linkPassword,
      }
      this.setRichTpl(item)
    },
    submitFormDataIntegrate() {
      // 提交保存接口之前的数据拼装
      const {
        path_type: pathType, prefix_neid: prefixNeid, from, neid, nsid,
      } = this.curFileInfo
      const formData = {
        path_type: pathType, // 所属空间,不能为空
        prefix_neid: prefixNeid, // 未知参数,path的前缀的neid
        from, // 未知参数,from
        neid, // 文件neid,不能为空
        nsid,
        creator_remark: this.linkShareFormData.CREATOR_REMARK_VALUE, // 备注名
        mode: '', // 上传下载预览初始化
        is_snapshot: this.linkShareFormData.IS_SNAPSHOT, // 文件快照
        is_login_verify: this.linkShareFormData.IS_LOGIN_VERIFY, // 登录认证
        description: this.linkShareFormData.DESCRIPTION_VALUE, // 说明
        is_approval: this.linkShareFormData.IS_APPROVAL, // 是否需要审批
        approve_desc: this.approveDesc, // 审批说明
      }
      if (this.linkShareFormData.DP_ID === true) {
        // 本地管控策略id
        formData.dp_id = this.linkShareFormData.DP_ID_VALUE
      } else {
        formData.dp_id = -1
      }
      if (this.linkShareFormData.LINK_ID) {
        // 创建外链后生成的ID
        formData.id = this.linkShareFormData.LINK_ID_VALUE
      } else {
        formData.id = null
      }
      if (this.code || this.linkShareFormData.DELIVERY_ID) {
        // 创建外链后生成的code
        formData.delivery_id = this.code
          ? this.code : this.linkShareFormData.DELIVERY_ID_VALUE
      } else {
        formData.delivery_id = null
      }
      // 上传下载预览
      formData.mode = ''
      if (this.linkShareFormData.DOWNLOAD) {
        // 允许下载
        formData.mode += 'r'
      }
      if (this.linkShareFormData.UPLOAD) {
        // 允许上传
        formData.mode += 'w'
      }
      if (this.linkShareFormData.PREVIEW) {
        // 允许预览
        formData.mode += 'p'
      }
      if (this.linkShareFormData.IS_PROTECTED) {
        // 添加提取码
        formData.password = this.$jsEncrypt.encrypt(
          this.linkShareFormData.IS_PROTECTED_VALUE,
        )
      } else {
        formData.password = null
      }
      if (this.linkShareFormData.MAX_EXPIRATION) {
        // 添加链接有效期
        formData.expiration = formatDate(this.linkShareFormData.MAX_EXPIRATION_VALUE, 'yyyy-MM-dd')
      } else {
        formData.expiration = -1
      }
      if (this.linkShareFormData.DOWNLOAD === true && this.MAX_DOWNLOAD_COUNT_CHECKBOX_STATUS) {
        // 限制下载次数
        formData.limited_download = this.linkShareFormData.MAX_DOWNLOAD_COUNT_VALUE
      } else {
        formData.limited_download = -1
      }
      if (this.linkShareFormData.DOWNLOAD === true && this.WATERMARK_CONTENT_CHECKBOX_STATUS) {
        // 普通水印打勾
        formData.is_checked_watermark = this.WATERMARK_CONTENT_CHECKBOX_STATUS
      } else {
        formData.is_checked_watermark = false
      }
      if (this.linkShareFormData.DOWNLOAD === true
        && this.lenovoData.accountinfo.delivery_safe_switch
        && this.EOD_ID_CHECKBOX_STATUS) {
        // 本地管控开启
        formData.eod = {
          max_expiration: null, // 添加阅读有效期
          is_file_recovery: false, // 允许文档还原,被移除的
          ctime: null, // 创建时间
          mtime: null, // 修改时间
        }
        if (this.otherData.isNew === false && this.linkShareFormData.EOD_ID_VALUE) {
          // 本地管控id
          formData.eod.id = this.linkShareFormData.EOD_ID_VALUE
        } else {
          formData.eod.id = null
        }
        if (this.linkShareFormData.EOD_PASSWORD) {
          // 添加本地密码
          formData.eod.eod_password = this.linkShareFormData.EOD_PASSWORD_VALUE
        } else {
          formData.eod.eod_password = null
        }
        if (this.linkShareFormData.EOD_MAX_EXPIRATION) {
          // 添加阅读有效期,开始,时间
          formData.eod.read_start_time = this.linkShareFormData.EOD_READ_START_TIME
        } else {
          formData.eod.read_start_time = null
        }
        if (this.linkShareFormData.EOD_MAX_EXPIRATION) {
          // 添加阅读有效期,结束,时间
          formData.eod.read_end_time = this.linkShareFormData.EOD_READ_END_TIME
        } else {
          formData.eod.read_end_time = null
        }
        if (this.linkShareFormData.MAX_READ_TIMES) {
          // 限制阅读次数
          formData.eod.max_read_times = this.linkShareFormData.MAX_READ_TIMES_VALUE
        } else {
          formData.eod.max_read_times = -1
        }
        if (this.linkShareFormData.MAX_READ_DURATION) {
          // 限制阅读时长
          formData.eod.max_read_duration = this.linkShareFormData.MAX_READ_DURATION_VALUE
        } else {
          formData.eod.max_read_duration = -1
        }
        if (this.linkShareFormData.IS_PRINT) {
          // 允许打印
          formData.eod.is_print = this.linkShareFormData.IS_PRINT
        } else {
          formData.eod.is_print = false
        }
        if (this.linkShareFormData.IS_READ_ONLY) {
          // 文档只读
          formData.eod.is_read_only = this.linkShareFormData.IS_READ_ONLY
        } else {
          formData.eod.is_read_only = false
        }
        if (this.linkShareFormData.IS_EXPIRED_DELETE) {
          // 失效后删除
          formData.eod.is_expired_delete = this.linkShareFormData.IS_EXPIRED_DELETE
        } else {
          formData.eod.is_expired_delete = false
        }
        if (this.WATERMARK_CONTENT_CHECKBOX_STATUS) {
          // 水印内容
          formData.eod.watermark_content = this.linkShareFormData.WATERMARK_CONTENT_VALUE
        } else {
          formData.eod.watermark_content = null
        }
        formData.eod = JSON.stringify(formData.eod)
      } else {
        formData.eod = JSON.stringify(null)
      }
      return formData
    },
    checkOrNot(check, isDisabled, e) {
      const event = e || window.event
      if (this.showInApprovalWarn) event.preventDefault()
      if (isDisabled) return false
      // if (this.showAuthWarn && t === 'link_out') event.preventDefault();
      this.linkShareFormData[check] = !this.linkShareFormData[check]
      // this.opt[t] = check
    },
    leftTimer(enTime) {
      // 第一次触发时间没有formate操作需要验证格式
      if (enTime.toString().indexOf('-') > -1) {
        const timeArr = enTime.split('-')
        const y = timeArr[0]
        const m = timeArr[1] - 1
        const d = timeArr[2]

        const leftTime = new Date(y, m, d, 23, 59, 59) - new Date() // 计算剩余的毫秒数
        const days = parseInt(leftTime / 1000 / 60 / 60 / 24, 10) // 计算剩余的天数
        const hours = parseInt((leftTime / 1000 / 60 / 60) % 24, 10) // 计算剩余的小时
        const minutes = parseInt((leftTime / 1000 / 60) % 60, 10)// 计算剩余的分钟

        this.lastday.days = days
        this.lastday.hours = hours
        this.lastday.minutes = minutes
      }
    },
    sendLink() {
      const key = typeof this.$refs.member_list.searchMemberParams.keyword === 'string'
        ? this.$refs.member_list.searchMemberParams.keyword.trim() : ''
      const { selected } = this.$refs.member_list
      if (key !== '') {
        if (!Util.validEmail(key)) {
          selected.push({ name: key, error: true })
          this.showTipsNoIcon(this.$t('以下标红的邮箱格式不正确，检查一下吧'))
          this.$refs.member_list.searchMemberParams.keyword = ''
          return
        }

        selected.push({ name: key })

        this.$refs.member_list.searchMemberParams.keyword = ''
      }
      if (document.querySelector('.email-error')) {
        this.showTipsNoIcon(this.$t('以下标红的邮箱格式不正确，检查一下吧'))
        return
      }
      const path = (this.metaData && this.metaData.path)
        || this.curFileInfo.path
      const data = {
        link: this.linkShareFormData.URL_VALUE,
        // test\qa\线上   message字段全部为空，咱也不知道这是干啥的   留着吧  - -
        message: this.mail_description,
        isfolder: false,
        name: Util.resolvePath(path).name,
        path,
      }
      const emailList = this.$refs.member_list.selected
      data.email = ''

      if (emailList.length === 0) {
        this.showTipsNoIcon(this.$t('邮箱不能为空'))
        return
      }
      for (let i = 0; i < emailList.length; i += 1) {
        data.email += `${(emailList[i].name).toString()};`
      }
      this.$refs.member_list.saveRecent(data.email) // 保存最近使用的邮箱
      data.email = data.email.substr(0, data.email.length - 1)
      if (this.linkStatus === 'save&copy') {
        this.createLink(() => {
          postData('sendLink', data).then((res) => {
            if (res.status === 200) {
              this.hasDelivery = true
              this.$emit('closeDialog', 'close')
              this.showTipsNoIcon(res.data.msg)
            }
          }).catch(() => {
            // 失败提示语，和web保持一致。
            this.showTipsNoIcon(this.$t('发送失败，请重新发送'))
          })
        })
      } else {
        postData('sendLink', data).then((res) => {
          if (res.status === 200) {
            this.hasDelivery = true
            this.$emit('closeDialog', 'close')
            this.showTipsNoIcon(this.$t(res.data.msg))
          }
        }).catch(() => {
          // 失败提示语，和web保持一致。
          this.showTipsNoIcon(this.$t('发送失败，请重新发送'))
        })
      }
    },
    showTips(info) {
      this.showTipsNoIcon(info)
    },
    watchSelected() {
      this.sendMailbtn = true// 显示发送邮件按钮
    },
    openClientWin(param) {
      if (Util.isClient()) {
        openUrlOutside({ url: param })
      } else {
        window.open(param, '_blank')
      }
    },
    isObjectValueEqual(a, b) {
      const aProps = Object.getOwnPropertyNames(a)
      const bProps = Object.getOwnPropertyNames(b)

      if (aProps.length !== bProps.length) {
        return false
      }

      for (let i = 0; i < aProps.length; i += 1) {
        const propName = aProps[i]
        if (a[propName].toString() !== b[propName].toString()) {
          return false
        }
      }

      // If we made it this far, objects
      // are considered equivalent
      return true
    },
    changeWarnMsg({
      contentTarget, content, showTarget, isShow,
    }) {
      this[contentTarget] = content
      this[showTarget] = isShow
    },
    checkDlLimit(val) {
      const { maxDownloadTimes } = this.controlledRule
      if (val === 0) {
        this.changeWarnMsg({
          contentTarget: 'dlWarnMsg',
          content: '下载次数已用尽',
          showTarget: 'showDlWarnMsg',
          isShow: true,
        })
        return
      }
      if (maxDownloadTimes && maxDownloadTimes !== -1) {
        // 对下载次数有最大限制
        if (val > maxDownloadTimes) {
          this.changeWarnMsg({
            contentTarget: 'dlWarnMsg',
            content: `最多可下载 ${maxDownloadTimes} 次`,
            showTarget: 'showDlWarnMsg',
            isShow: true,
          })
          this.needAuth = true
        } else {
          this.changeWarnMsg({
            contentTarget: 'dlWarnMsg',
            isShow: false,
          })
          this.needAuth = false
        }
      }
    },
    /**
     *@description 日期控件改变状态
     */
    datePicked(date) {
      const selectDate = new Date(date).getTime(); const currentDate = new Date().getTime()
      if (selectDate > currentDate) {
        this.param.delivery_expired = false
      }
      this.leftTimer(date)
    },
  },
}
</script>

<style lang="less" scoped>
@import '~less/button.less';
@import '~less/file.less';

.createNewLink{
  .s-btn{
    float: right;
  }
}
.label{
  color: #929CA9;
  font-size: 14px;
}
.setNewLink.zh{
  .watermark-tip{
    position: relative;
    left: -50px;
  }
}
.setNewLink.en{
  .link-intro{
    .link-share-input{
      width:364px;
    }
  }
  input::placeholder {
    font-size: 12px;
  }
}
.setNewLink{
  position: relative;
  .mask{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100;
    background-color: rgba(255,255,255,0.4);
    img{
      position: absolute;
      left: 0;
      right: 0;
      width: 60px;
      height: 60px;
      top: 40%;
      margin: auto;
      display: block;
    }
  }
}
.ico-i-tip{
  position: relative;
  z-index: 10;
  width:19px;
  height:19px;
  display: inline-block;
  &:before{
    content: '';
    width: 15px;
    height: 15px;
    margin: 7px auto 0;
    background: url('../../source/msg.svg') no-repeat;
    display: block;
  }
  .tip-show{
    position: absolute;
    padding: 8px 12px;
    width: 200px;
    border-radius: 2px;
    background-color: #3D464C;
    color: white;
    letter-spacing: 0.27px;
    word-break: break-all;
    line-height: 17px;
    display: none;
    &:before{
      content: '';
      position: absolute;
      width: 15px;
      height: 15px;
      background-color: #3D464C;
      transform: rotate(45deg);
      display: block;
      z-index: -1;
    }
  }
}
.watermark-label {
  .ico-i-tip{
    top: 2px;
  }
}
.ico-i-tip:hover{
  .tip-show{
    display: block;
  }
}
.snapshot.ico-i-tip{
  .tip-show{
    top:32px;
    left: -150px;
    &:before{
      top: -5px;
      left: 150px;
    }
  }
}
.loginverify.ico-i-tip{
  .tip-show{
    top:32px;
    left: -100px;
    &:before{
      top: -5px;
      left: 100px;
    }
  }
}
.eod-tip.ico-i-tip{
  .tip-show{
    top:32px;
    left: -100px;
    &:before{
      top: -5px;
      left: 100px;
    }
  }
}
.link-warn{
  font-size: 14px;
  letter-spacing: 0.2px;
  z-index: 11;
  background: #fff1dc;
  left: 0;
  top: 50px;
  color: #FFAB27;
  min-height: 20px;
  text-align: center;
  padding: 10px;
}
.content-box{
  height: 470px;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 8px 0 0;
  min-width: 478px;
  color: #4D5365;
  font-size: 14px;
  padding-right: 4px;
  .dialog-content{
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 24px;
    .create-btn-disable{
      background: #85B2FD;
      border-color: #85B2FD;
    }
    .box-checkbox-inner {
      top: -1px;
    }
  }
  .dialog-content::-webkit-scrollbar {
    width: 8px;
    height: 4px;
  }
  .dialog-content::-webkit-scrollbar-thumb  {
    opacity: 0.6;
    background: #C1C7CD;
    border-radius: 100px;
  }
}
.delivery-icon{
  width: 32px;
  height: 32px;
  display: inline-block;
  text-align: center;
  line-height: 32px;
  border-radius: 16px;
  background: #F8F8F8;
  border: none;
  .icon-i-link {
    display: inline-block;
    width: 32px;
    height: 32px;
    vertical-align: middle;
  }
}
.content-box::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.content-box::-webkit-scrollbar-thumb {
  opacity: 0.6;
  background: #C1C7CD;
  border-radius: 100px;
}
.lv-btn.primary-btn{
  padding: 0 2px;
  margin-right: 6px;
  float:right;
  background: #0a64fa;
}
.download-btn{
  width: 80px;
  height: 40px;
  display: block;
  background: #2c7df1;
  border: 1px solid #4d5365;
  text-align: center;
  line-height: 40px;
  color: white;
}
/***链接分享***/
.link-intro{
  padding-top: 20px;
  padding-bottom: 24px;
  .label{
    margin-top: 6px;
    float: left;
  }
  .link-share-input{
    width: 404px;
    height: 32px;
    line-height: 32px;
    padding-left: 12px;
    margin-left: 9px;
    box-sizing: border-box;
    background-color: #F0F2F6;
    border-radius: 2px;
    float: right;
    border: none;
    resize: none;
    &:focus{
      padding: 8px;
      height: 88px;
      color: #1B2733;
      line-height: normal;
      border: 1px solid #DADADA;
      background-color: white;
      outline: none;
    }
  }
  .link-share-input + span{
    display: none;
  }
  .link-share-input:focus + span{
    display: inline;
  }
}
.config-row{
  margin-top: 12px;
  min-height: 32px;
  position: relative;
  .item-wrapper{
    width: 145px;
  }
  .el-input--suffix {    //input框高度
    .el-input__inner{
      height: 30px;
    }
  }
  & > input{
    &::placeholder{
      font-size: 12px;
    }
    padding-left: 15px;
    width: 123px;
    height: 30px;
    border-radius: 2px;
    outline: none;
    border: 1px solid #C6CDD7;
  }
  input.input-invalidate{
    &::placeholder{
      font-size: 12px;
    }
    border-color: #FF1B43;
  }
  .label{
    width: 90px;
    display: inline-block;
  }
  .icon-caret_down{
    position: absolute;
    left: 220px;
    top: 10px;
    cursor: pointer;
  }
  .pw-input-red{
    border: 1px solid red;
  }
}
.link-row {
  height: 32px;
  width: 100%;
  border-bottom: 1px solid rgba(193,199,205,0.4);
  padding-bottom: 20px;
  position: relative;
  .add-email{
    height: auto;
    border: none;
    background: #fff;
    text-align: left;
    .label{
      display: inline-block;
      height: 32px;
      float:left;
    }
  }
}
.link_share h1{
  font-size: 14px;
  font-weight: normal;
  margin-top: 23px;
  margin-bottom: 12px;
  color: #7f7f7f;
}
.link-row .link-url-span{
  &.creating{
    width: 271px;
  }
  width: 276px;
  height: 32px;
  vertical-align: middle;
  /*margin-left: 15px;*/
  padding-left: 10px;
  text-align: left;
  border-radius: 3px;
  display: inline-block;
  margin-right: 9px;
  position: relative}
.no-link-border {
  border: none!important;
  width: 268px;
}
.link-row .approval-tip{
  position: absolute;
  top: 36px;
  background: #fff1dc;
  color: #FFAB27;
  display: none;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.link-row .link-url-span .link-txt-password{
  display: inline-block;
  left: 207px;
  overflow: hidden;
  position: absolute;
  text-overflow: ellipsis;
  top: 8px;
  white-space: nowrap;
  width: 104px;
}
.maxlength-warn-txt{
  color: red;
}
.link-option{
  padding-top: 16px;
  label{
    margin-left: 6px;
    margin-right: 12px;
  }
  .remark-row{
    position: relative;
    height: 32px;
    .label{
      height:32px;
      line-height: 32px;
      float:left;
    }
    .remark{
      height:32px;
      line-height: 32px;
      padding-left: 8px;
      float: left;
      &:hover{
        background-color: #F0F2F6;
      }
    }
    .icon-remark{
      width: 32px;
      height:32px;
      line-height: 32px;
      font-size: 17px;
      text-align: center;
      float: right;
      &:before{
        content: "";
        width: 17px;
        height: 17px;
        display: block;
        margin: 8px auto 0;
        background: url("../../source/edit.svg") no-repeat;
      }
    }
    & .remark-name {
      border: 1px solid white;
      outline: none;
      width: 372px;
      height: 30px;
      padding: 0 5px 0 8px;
      color: #4D5365;
      border-radius: 2px;
      &:focus {
        border: 1px solid #C6CDD7;
      }
    }
  }
  .check-auth{
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(193,199,205,0.4);
    .auth-row{
      &.upload{
        .mutex-tip{
          position: relative;
          margin: 0 5px 0 -3px;
          cursor: pointer;
          i{
            display: inline-block;
            width: 13px;
            height: 13px;
            background: url("../../source/noticeIcon.svg") center center no-repeat;
          }
          span {
            display: none;
            width: 210px;
            position: absolute;
            left: -108px;
            top: -63px;
            padding: 8px 13px 12px 10px;
            text-align: center;
            line-height: 16px;
            font-size: 12px;
            color: #FFFFFF;
            background: #4D5365;
            border-radius: 2px;
            z-index: 1;
            &::after{
              content: '';
              display: block;
              width: 0;
              height: 0;
              border-right: 5px solid #4D5365;
              border-bottom: 5px solid #4D5365;
              transform: rotate(45deg);
              position: absolute;
              bottom: -2px;
              left: 111px;
            }
          }
          &:hover{
            i{
              background: url("../../source/noticeIconHover.svg")
                center center no-repeat;
            }
            span{
              display: block;
            }
          }
        }
      }
    }
  }
  .controlled-item{
    .item-wrapper{
      position: relative;
      margin-top: 20px;
      display: inline-block;
      &.disabled{
        &::before{
          content: '';
          display: inline-block;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 1;
          background: hsla(0,0%,100%,.5);
        }
      }
    }
  }
  .eod{
    .item-wrapper{
      position: relative;
      display: inline-block;
      &.disabled{
        &::before{
          content: '';
          display: inline-block;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 1;
          background: hsla(0,0%,100%,.5);
        }
      }
    }
    padding: 20px 0;
    border-bottom: 1px solid rgba(198, 205, 215 ,0.4);
    .eod-detail{
      padding-left: 20px;
      .eod-row{
        height:32px;
        margin-top: 5px;
        .item-wrapper{
          width: 130px;
          line-height:32px;
          label{
            margin-right: 0;
          }
        }
      }
      .eod-validate{
        padding-left: 134px;
        padding-top: 5px;
        height: 14px;
      }
    }
  }
  .secure-config{
    border-bottom: 1px solid rgba(198, 205, 215 ,0.4);
    padding: 20px 0 0 0;
    .secure-validate{
      padding: 5px 0 5px 166px;
      height: 16px;
    }
    .secure-row{
      height:32px;
      margin-top: 12px;
      input{
        color:#1B2733
      }
      .secure-wrapper{
        position: relative;
        line-height: 32px;
        .secure-label{
          width: 126px;
          display: inline-block;
        }
      }
      .secure-wrapper.disabled:before{
        content: "";
        display: inline-block;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1;
        background: hsla(0,0%,100%,.5);
      }
    }
  }
  .watermark{
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(198, 205, 215 ,0.4);
    .watermark-wrapper{
      line-height: 32px;
      .watermark-label{
        width: 116px;
        display: inline-block;
      }
      .watermark-tip{
        font-size: 12px;
      }
    }
    .watermark-wrapper.disabled:before{
      content: "";
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 1;
      background: hsla(0,0%,100%,.5)
    }
  }
}
.link-out-en {
  display: block;
  margin-left: 80px;
  margin-top: 10px;
  padding: 0px;
}
.en .config-row {
  & > .label {
    width: 120px;
  }
  .icon-caret_down{
    left: 240px;
  }
}
.link-instruction{
  // margin-top: 20px;
  padding-bottom: 24px;
  .link-instruction-label{
    float:left;
  }
  textarea{
    width: 370px;
    border-radius:2px;
    border:1px solid #C6CDD7;
    padding: 6px 12px 14px 14px;
    margin-left: 20px;
    font-size:12px;
    color: #323D4C;
    box-sizing: border-box;
    background-color:transparent;
    float: right;
  }
}
.rm-link-pwd,.add-link-pwd{
  color: #0a64fa;
  cursor: pointer;
  line-height: 32px;
}
.rm-link-pwd{
  padding-left: 10px;
  font-size: 12px;
}
.url-show{
}
.icon-checkmark,.icon-checkbox{
  cursor: pointer;
}
input[type="checkbox"]{
  display: none;
}
.update-file{
  line-height: 32px;
}
.update-file-disabled {
  display: none;
}
.mirror-ver-tip{
  font-size: 12px;
  color: #C6CDD7;
}
.no-link{
  color: #929CA9;
  line-height: 32px;
}
.has-link{
  display: inline-block;
  width: 192px;
  line-height: 32px;
  text-decoration: underline;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #0a64fa;
}
.has-link:visited{
  color: #0a64fa;
}
.calendar-box{
  display: inline-block;
  vertical-align: middle;
  /deep/.el-date-editor.input-invalidate{
    .el-input__inner{
      border: 1px solid #ff1b43;
    }
  }
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 140px;
    border-radius: 2px;
    input{
      height: 34px;
      border: 1px solid #c6cdd7;
      border-radius: 2px;
    }
  }
  /deep/ .el-input--suffix .el-input__inner{
    padding-right: 0px;
  }
}
.link-em-days{
  color: #929CA9;
  font-size: 12px;
  padding-left: 10px;
}
.text-invalidate{
  color: #FF1B43;
  font-size:12px;
}
.link_ex_msg{
  color: #FF1B43;
  display: inline-block;
  width: auto;
  vertical-align: middle;
}
.link_copy_box{
  opacity: 0;
}
.count{
  display: inline-block;
  color: #929ca9;
  width: 40px;
  overflow: hidden;
  padding-left: 12px;
  margin-right: 30px;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  vertical-align: middle;
}
.link-instruction-input, #add-email{
  display: inline-block;
  margin-left: 20px;
  width: 385px;
  line-height: 1.5;
  min-height: 32px;
  height: auto;
  background: rgba(248, 248, 248, 0.4);
  padding-left: 15px;
  font-size: 12px;
  border: 1px solid #ffffff;
  border-radius: 2px;
  float: right;
}
#add-email{
  padding-left: 0px;
  margin-top: 0px;
  width: 370px;
}
.delivery-qrcode{
  width: 120px;
  height: 120px;
}
.link-share-two-dimensional-code-icon {
  border-radius: 3px;
  display: inline-block;
  height: 32px;
  line-height: 32px;
  position: relative;
  text-align: center;
  margin-left: 8px;
  width: 32px;
  float:right;
  &:hover{
    background-color: #E8EBEF;
  }
  &:before{
    content:'';
    width: 15px;
    height: 15px;
    margin: 10px auto 0;
    display: block;
    background: url("../../source/share.svg") no-repeat;
  }
}
.link-share-two-dimensional-code-box {
  background-color: #fff;
  position: absolute;
  padding: 0 24px;
  box-sizing: border-box;
  z-index: 99;
  width: 480px;
  min-height: 442px;
  top: 40px;
  left: -440px;
  box-shadow: 0px 0 5px 0px hsl(0, 0%, 60%);
  &:before{
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-top: 10px solid #FFF;
    border-left: 10px solid #FFF;
    transform: rotate(45deg);
    position: absolute;
    right: 25px;
    top: -5px;
    box-shadow: -1px -1px 1px 0px rgba(153,153,153, 0.4);
    z-index: -6;
  }
}
.link-share-two-dimensional-code-pic {
  margin: 29px auto 8px;
  width: 120px;
  height: 120px;
  background-color: #fff;
}
.link-share-two-dimensional-code-state {
  text-align: center;
  font-size: 14px;
  color: #575757;
  margin: -3px auto;
  height: 18px;
  line-height: 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(198, 205, 215 ,0.4);
}
.dialogfooter{
  min-height: 60px;
  padding-top: 20px;
}
.sendLink{
  min-width: 80px;
  height: 32px;
  border-radius: 3px;
  padding: 0 5px;
  box-sizing: border-box;
  right: 10px;
  background: #0A64FA;
  border: 1px solid #0A64FA;
  color: #ffffff;
  text-align: center;
  font-size: 14px;
  line-height: 32px;
  border: none;
  outline: none;
  cursor: pointer;
  float: right;
}
.sendLink.cancel{
  border: 1px solid #C1C7CD;
  border-radius: 3px;
  background-color: white;
  color: #323D4C;
  margin-right: 12px;
}
.newLink, .historyLink{
  color: #0a64fa;
  cursor: pointer;
}
.newLink{
  float: left;
}
.historyLink{
  float: right;
}
.disable-check{
  pointer-events:none;
}
.disable-check:before{
  color: #929CA9!important;
}
  #en{
    .createNewLink{
      .calendar-box .el-date-editor.el-input{
        width: 143px;
      }
      .config-row>input{
        padding-left: 10px;
        width: 136px;
      }
      .link-share-input{
        width: 364px;
      }
      .url-show{
        padding: 0;
        margin: 0;
      }
      .link-row .link-url-span .link-txt-password{
        left: 195px;
      }
    }
  }
</style>
